import React from 'react'
import { 
    CellsTitle, Cells, CellFooter, CellBody, Form, FormCell, Button,
    Toast, Dialog, Toptips, Radio, CellHeader, Switch, Label, Input,
    ActionSheet, Select
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { getJsonFromUrl } from '../../utils'
import { WKVisible } from '../../components/wk'
import {TimeStream, isLZWKAPP} from '../../utils'
import { updateSuccess, goBack } from '../../utils/connectApp'
import Header from '../../components/liveroomLecturer/Header'
import '../../css/page/ChannelLectureEditPage.css'

import questionImg from '../../images/question.png'

class LectureEditLimitPage extends React.Component {
    constructor (props) {
        super(props)
        this.type = /^\/lecture\//.test(props.location.pathname) ? 'lecture' : 'channel'
        this.state = {
            // password, free, unfree
            isLimit: false,
            limitMoney: 0,
            time: '',
            originMoney: 0,
            alertDialog: {
                isShow: false,
                text: '',
            },
            alertDialogTip: {
                isShow: false,
                text: '',
            },
            days: [1, 2, 3, 7, 14, 30],
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            selectDay: '7',

            isAutoLimit: false,
        }
    }
    componentDidMount () {
        document.title = '限时特价'
        this.fetchData()
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    fetchData () {
        this.setState({ isPending: true })
        if (this.type === 'lecture') {
            axios.get(`/api/lecture/${this.props.params.id}/edit_info`)
                .then(res => {
                    const limit_money = res.data.data.lecture.limit_money || {}
                    let selectDay = '7'
                    if (limit_money.expire_timestamp) {
                        let delTime = limit_money.expire_timestamp - limit_money.start_timestamp
                        selectDay = delTime < 0 ? 1 : ~~(delTime / 86400)
                        selectDay = this.state.days.indexOf(selectDay) === -1 ? '' : selectDay
                    }
                    this.setState({ 
                        isLimit: res.data.data.lecture.need_limit_money,
                        originMoney: res.data.data.lecture.money / 100,
                        limitMoney: (limit_money.money / 100) || 0,
                        time: limit_money.start_timestamp || ~~(Date.now() / 1000),
                        isPending: false,
                        isAutoLimit: !!limit_money.expire_renew,
                        selectDay
                    })
                })
        } else {
            axios.get(`/api/marketing/promoprice/${this.props.params.id}/edit_info?scope=channel`)
                .then(res => {
                    const limit = res.data.data.promoprice
                    const originMoney = res.data.data.original_money
                    let selectDay = '7'
                    if (limit.start_timestamp) {
                        let delTime = limit.deadline_timestamp - limit.start_timestamp
                        selectDay = delTime < 0 ? 1 : ~~(delTime / 86400)
                        selectDay = this.state.days.indexOf(selectDay) === -1 ? '' : selectDay
                    }
                    this.setState({ 
                        isLimit: limit.enabled || getJsonFromUrl().fr === 'pc_set',
                        originMoney: originMoney / 100,
                        limitMoney: limit.price / 100 || 0,
                        time: limit.start_timestamp || ~~(Date.now() / 1000),
                        isPending: false,
                        isAutoLimit: !!limit.deadline_renew,
                        selectDay
                    })
                })
        }
        
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    showAlertTip (text) {
        this.setState({
            alertDialogTip : { isShow: true, text }
        })
    }
    verify () {
        if (this.state.isLimit) {
            if (!/^(-)?(([1-9]{1}\d*)|([0]{1}))(\.(\d){1,2})?$/.test(this.state.limitMoney)) {
                return {
                    status: false,
                    msg: '请输入正确的价格',
                }
            }
            if (this.state.limitMoney < 0) {
                return {
                    status: false,
                    msg: '限时价格不能小于0',
                }
            }
            if (this.state.limitMoney > this.state.originMoney) {
                return {
                    status: false,
                    msg: '限时价格必须小于当前价格',
                }
            }
            if (!this.state.time) {
                return {
                    status: false,
                    msg: '请选择特价开始时间',
                }
            }
            if (!this.state.selectDay) {
                return {
                    status: false,
                    msg: '请选择特价持续天数',
                }
            }
        }
        return { status: true }
    }
    onSubmit (e) {
        const verifyRes = this.verify()
        let { selectDay } = this.state
        if (!verifyRes.status) {
            return this.showTip(verifyRes.msg)
        }
        this.setState({ isPending: true })
        if (this.type === 'lecture') {
            let startTime = ~~(Date.now() / 1000 + 86400),
                endTime = this.state.isLimit ? this.state.time : startTime
            endTime = endTime + selectDay * 86400
            axios.post(`/api/lecture/${this.props.params.id}/edit`, qs.stringify({
                lm_enabled: this.state.isLimit,
                lm_start: ~~(this.state.isLimit ? this.state.time : startTime),
                lm_expire: ~~endTime,
                lm_money: (this.state.limitMoney * 100).toFixed(0),
                lm_expire_renew: this.state.isAutoLimit ? 1 : 0,
            }))
                .then(res => {
                    this.setState({ isPending: false })
                    if (res.data.code !== 0) {
                        return this.showTip(res.data.msg)
                    }
                    this.showAlert('修改成功')
                })
        } else {
            let startTime = ~~(Date.now() / 1000 + 86400),
                endTime = this.state.isLimit ? this.state.time : startTime
            startTime = TimeStream(startTime)
            endTime = TimeStream(endTime + selectDay * 86400)
            axios.post(`/api/marketing/promoprice/${this.props.params.id}/edit`, qs.stringify({
                scope: this.type,
                price: (this.state.isLimit ? this.state.limitMoney * 100 : 0).toFixed(0),
                enabled: this.state.isLimit,
                start_time: this.state.isLimit ? TimeStream(this.state.time) : startTime,
                deadline_enabled: this.state.isLimit,
                deadline_renew: this.state.isAutoLimit ? 1 : 0,
                deadline: endTime
            }))
                .then(res => {
                    this.setState({ isPending: false })
                    if (res.data.code !== 0) {
                        return this.showTip(res.data.msg)
                    }
                    this.showAlert('修改成功')
                })
        }
    }
    onChangeTime (e) {
        const value = e.target.value.replace(/-/g,"/").replace(/T/g," ")
        const timestamp = Date.parse(value) / 1000
        this.setState({ time: timestamp })
    }
    onClickSuccessDialogOk () {
        if (isLZWKAPP()) {
            updateSuccess({ type: this.type })
            goBack()
        } else if (/from=optimize/.test(location.search)) {
            history.back()
        } else {
            location.assign(`/${this.type}/${this.props.params.id}`)
        } 
    }
    autoLimitTip = () =>{
        this.showAlertTip('限时特价到期前1小时，会自动开启新的一轮限时特价，设置的价格与持续天数保持不变。')
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-lecture-edit-page">
                    <div className="limit-page">
                        <Header title='限时特价' />
                        <p className="intro" style={{paddingTop: 0}}>
                            在活动时间可以设置特价来提升购买
                        </p>
                        <Form className={this.state.selectedRadio !== 'free' ? 'margin-bottom' : ''} radio>
                            <FormCell>
                                <CellHeader>
                                    <Label>当前价格（元）</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input 
                                        onChange={e => this.bindValue(e, 'originMoney')} 
                                        value={this.state.originMoney}
                                        disabled={true}
                                    />
                                </CellBody>
                            </FormCell>
                        </Form>
                        <Form>
                            <FormCell radio>
                                <CellBody>开启限时特价</CellBody>
                                <CellFooter>
                                    <Switch 
                                        checked={this.state.isLimit} 
                                        onChange={e => this.setState({ isLimit: e.target.checked })} 
                                    />
                                </CellFooter>
                            </FormCell>
                            <WKVisible create={this.state.isLimit} tag={null}>
                                <FormCell>
                                    <CellHeader>
                                        <Label>限时价格（元）</Label>
                                    </CellHeader>
                                    <CellBody>
                                        <Input 
                                            onChange={e => this.bindValue(e, 'limitMoney')} 
                                            type="number"
                                            placeholder="请输入价格"
                                            value={this.state.limitMoney}
                                        />
                                    </CellBody>
                                </FormCell>
                            </WKVisible>
                            <WKVisible create={this.state.isLimit} tag={null}>
                                <FormCell className='time-cell'>
                                    <CellHeader>
                                        <Label style={{width: '130px'}}>特价开始时间</Label>
                                    </CellHeader>
                                    <CellBody>
                                        <Input 
                                            className='time-input'
                                            type="datetime-local" 
                                            onChange={e => this.onChangeTime(e)} 
                                            value={TimeStream(this.state.time).replace(' ', 'T')}
                                        />
                                    </CellBody>
                                </FormCell>
                            </WKVisible>
                            <WKVisible create={this.state.isLimit} tag={null}>
                                <FormCell className='time-cell'>
                                    <CellHeader>
                                        <Label style={{width: '130px'}}>特价持续天数</Label>
                                    </CellHeader>
                                    <CellBody className="text-right">
                                        <Select className="edit-day" dir="rtl" onChange={e => this.bindValue(e, 'selectDay')} value={this.state.selectDay}>
                                            {this.state.days.map(item => {
                                                return <option value={item} key={item}>{item}天</option>
                                            })}
                                        </Select>
                                    </CellBody>
                                </FormCell>
                            </WKVisible>
                            <WKVisible create={this.state.isLimit} tag={null}>
                                <FormCell switch>
                                    <CellBody>限时特价自动续期
                                        <img className="lecture-limit__question-icon" src={questionImg} onClick={this.autoLimitTip}/>
                                    </CellBody>
                                    <CellFooter>
                                        <Switch
                                            checked={this.state.isAutoLimit}
                                            onChange={e => {
                                                this.setState({ isAutoLimit: e.target.checked })
                                                if (e.target.checked){
                                                    setTimeout(() =>{
                                                        this.autoLimitTip()
                                                    },200)
                                                }
                                            }}
                                        />
                                    </CellFooter>
                                </FormCell>
                            </WKVisible>
                        </Form>
                        <WKVisible show={false}>
                            <p className="intro">
                                结束时间请设置在7天以内
                            </p>
                        </WKVisible>
                        <div className="wk-btn-90 padding-top-10">
                            <Button onClick={e => this.onSubmit(e)}>保存</Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickSuccessDialogOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定' ,onClick: () =>{
                            this.setState({alertDialogTip : { isShow: false, text: '' }})
                        }}
                ]} show={this.state.alertDialogTip.isShow}>
                    {this.state.alertDialogTip.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </div>
        )
    }
}

export default LectureEditLimitPage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditLimitPage.js